<h1 mat-dialog-title>Sessão</h1>

<mat-dialog-content>
  <p class="jwt-session pb-16">{{ data }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Sair</button>
</mat-dialog-actions>
